(function (appSetup) {

	appSetup.handlebarsSetup = function (app) {
		// dep's
		Swag.registerHelpers(Handlebars);
		Handlebars.partials = Handlebars.templates = appSetup.templates;


		var splitCamelCase = function (string) {
			return string.replace(/([A-Z])/g, ' $1')
				.replace(/^./, function (str) {
					return str.toUpperCase();
				});
		};

		var counter = {
			num: 0,
			reset: function () {
				counter.num = 0;
			},
			add: function (opts) {
				counter.num++;
			},
			sub: function (opts) {
				counter.num--;
			},
			check: function (numToCheck, opts) {
				var fn = opts.inverse;
				if (counter.num == numToCheck) {
					fn = opts.fn;
				}
				// return fn;
				var html = fn(this);
				return new Handlebars.SafeString(html);
			}
		};

		var customMotors = {
			propToShow: ["frameSize", "hp", "voltage", "rpm", "shaftOrientation"],
			getCustomMotorName: function (product) {
				var name = "Custom motor";
				customMotors.propToShow.forEach(function (prop) {
					if (product.customProductData[prop] != null) {
						name = name + ", " + product.customProductData[prop] + " " + splitCamelCase(prop);
					}
				});
				return name;
			},
			checkIfCustomMotorProps: function (key, value, opts) {
				if (customMotors.propToShow.indexOf(key) > -1 && value != null) {
					return opts.fn(this);
				}
			},
		};

		var checkIfAnyTrue = function () {
			var args = [].slice.apply(arguments);
			var opts = args.pop();

			var fn = opts.inverse;
			for (var i = 0; i < args.length; ++i) {
				if (!args[i]) continue;

				fn = opts.fn;
				break;
			}
			return fn(this);
		};

		var checkIfRoleIs = function (rmRole, roleToCheck, opts) {
			var roleAlias = {
				salesManager: "ROLE_RMSALESMANAGERGROUP",
				internalUser: "ROLE_RMINTERNALGROUP"
			};
			if (rmRole == null || rmRole != roleAlias[roleToCheck]) {
				return;
			}
			return opts.fn();
		};

		var checkIfSpaDisplayed = function (spaNumber, spaList) {

			if (!spaNumber || spaNumber == "STD-PRICE") {
				return "";
			}

			var spaNumberListToCheck = [];
			spaList.forEach(function (el) {
				var spaNumberToCheck = el.split("-")[0];
				spaNumberListToCheck.push(spaNumberToCheck);
			});

			var isNotListed = false;
			if (spaNumberListToCheck.indexOf(spaNumber) < 0) {
				isNotListed = true;
			}

			if (isNotListed) {
				return spaNumber;
			}
		};

		var checkIfNotListed = function (spaNumber, spaList) {
			if (!spaNumber || spaNumber == "STD-PRICE") return;

			var spaNumberListToCheck = [];
			spaList.forEach(function (el) {
				var spaNumberToCheck = el.split("-")[0];
				spaNumberListToCheck.push(spaNumberToCheck);
			});

			var isNotListed = false;

			if (spaNumberListToCheck.indexOf(spaNumber) < 0) {
				isNotListed = true;
			}

			if (isNotListed) {
				return "selected";
			}
		};

		var checkIfSpaSelected = function (spaNumber, spaToCheck) {
			var spaNumberToCheck = spaToCheck.split("-")[0];
			if (spaNumber == spaNumberToCheck) {
				return "selected";
			}
		};
		
		var stripDetails = function (stripDetailsRaw) {
			
			var stripDetails = stripDetailsRaw.replace("GE MOTORS","");
			stripDetails = stripDetails.replace("WAREHOUSE","");
			stripDetails = stripDetails.replace("CANADA","");
			stripDetails = stripDetails.replace("REGIONAL","");
			stripDetails = stripDetails.replace("INV","");
			stripDetails = stripDetails.replace("WHS","");
			stripDetails = stripDetails.replace("ORG","");
			stripDetails = stripDetails.replace("(PRT)","");
			stripDetails = stripDetails.replace("WAR","");
			stripDetails = stripDetails.replace("TN","");
			stripDetails = stripDetails.replace("WareHouse","");
			return stripDetails;
		};

		var parseCompDescription = function (desc, opts) {
			// Rugged cast iron design for long life#~GEGARD 1800TM Inverter duty insulation system meets NEMA MG1-31#~
			if (desc != null) {
				var descArr = desc.split("#~");
				if (descArr[descArr.length - 1] == "") {
					descArr.pop();
				}
				return opts.fn(descArr);
			}
		};

		var convertUnixTsToDate = function (timestamp) {
			if (!timestamp) return;

			timestamp = timestamp / 1000;

			var dateString = moment.unix(timestamp).format("MM/DD/YYYY");
			return dateString;
		};
       var convertDateFormat = function (dateformat) {
			if (!dateformat) return;
			var schShipDate = new Date(dateformat);
            var month = (schShipDate.getMonth()+1);
            var date = schShipDate.getDate();
            var year = schShipDate.getFullYear();
            var formattedSchShipDate = month + "/" + date + "/" + year ;
            return formattedSchShipDate;
		};
		
		// cant remember why there are two of these
		// remove unused
		var getCurrencyAndTotalPrice = function (product, isPcPart, opts) {
			if (!isPcPart) {
				return new Intl.NumberFormat('de-DE', {
					style: 'currency',
					currencyDisplay: 'code',
					currency: 'USD'
				}).format(product.totalPrice);
			} else {
				return new Intl.NumberFormat('de-DE', {
					style: 'currency',
					currencyDisplay: 'code',
					currency: 'GBP'
				}).format(product.totalPrice);
			}
		};
		var getCurrencyAndPrice = function (product, isPcPart, opts) {
			if (!isPcPart) {
				return new Intl.NumberFormat('de-DE', {
					style: 'currency',
					currencyDisplay: 'code',
					currency: 'USD'
				}).format(product.listPrice);
			} else {
				return new Intl.NumberFormat('de-DE', {
					style: 'currency',
					currencyDisplay: 'code',
					currency: 'GBP'
				}).format(product.listPrice);
			}
		};
		var getAlias = function (keyName) {
			var aliases = {
				pcParts: "PC Parts",
				rmProducts: "Low Voltage Motors"
			};
			return aliases[keyName];
		};
		var checkIfProductHaveKits = function (product, kits, opts) {
			if (kits && Object.keys(kits).length !== 0) {
				for (var kit in kits) {
					if (product.code == kit) {
						product.kits = kits[kit];
						return opts.fn(product);
					}
				}
			}
			return;
		};

		var checkIfCompCatalog = function (product, refs, opts) {
			if (refs && refs.length !== 0) {
				var competitors = [];
				refs.forEach(function (el) {
					if (product.code == el.source.name) {
						competitors.push(el);
					}
				});
				product.competitors = competitors;
				return opts.fn(product);
			}
			return;
		};

		var getClassIfProductIsKit = function (product, kits) {
			if (kits[product.code] != null && Object.keys(kits[product.code]).length != 0) {
				return "back-blue";
			} else {
				return "";
			}
		};

		var getDescriptionIfProductIsKit = function (entry, kits) {
			if (kits[entry.product.code] != null && Object.keys(kits[entry.product.code]).length != 0) {
				var productsString = "";
				var msg = "";
				kits[entry.product.code].forEach(function (el, idx, arr) {
					if (arr.length == idx + 1) {
						productsString = productsString + el;
					} else {
						productsString = productsString + el + ", ";
					}
				});
				if (entry.isTestAdder) {
					msg = "This Adder comes with ";
				} else {
					msg = "This Kit & Accessory comes with ";
				}
				return msg + productsString;
			} else {
				return;
			}
		};

		var parseDataPack = function (key) {

			var jsonDataPack = {
				"DATAPACK": "Data Pack",
				"CONNECTIONDIAGRAM": "Connection Diagram",
				"MOTORSPECIFICATION": "Motor Specification",
				"OUTLINEDRAWING": "Outline Drawing",
				"MOTORPERFORMANCE": "Perfomance Data",
				"THREEDIMDRAWING": "3D Drawing",
				"THREEDIMOUTLINE": "3D Outline",
				"SparePartsSpecification": "Spare Parts Specification"
			};

			if (jsonDataPack.hasOwnProperty(key)) {
				return jsonDataPack[key];
			}

			return key;
		};
		
		var addAvailabilityList = function (availabilityList){
			var avalTotal = 0;
			for (index in availabilityList) {
				avalTotal = parseInt(avalTotal) + parseInt(availabilityList[index].avalQty);
			}
			if(avalTotal > 0)
			{
				return avalTotal + " in Stock";
			}
			else
			{
				return "Out of Stock";
			}
		}
		
		var addLocalVariable = function (varName, varValue, options){
			 options.data.root[varName] = varValue;
		}
		
		var equalString = function (string1,string2,options) {
			if(string1==string2)
				{
				return options.fn(this);
				}
			else
				{
				return options.inverse(this);
				}
			
		}
		

		Handlebars.registerHelper('toUpperCase', function(str) {
			  return str.toUpperCase();
			});
			Handlebars.registerHelper('formatRepl', function(dateStr) {
                    if (!dateStr) return '';
                    // Extract year, month, and day from the date string (assuming format is YYYYMMDD)
                    var year = dateStr.substring(0, 4);
                    var month = dateStr.substring(4, 6);
                    var day = dateStr.substring(6, 8);

                    // Return in MM/DD/YYYY format
                    return month + '/' + day + '/' + year;
                });
		Handlebars.registerHelper('counterAdd', counter.add);
		Handlebars.registerHelper('counterSub', counter.sub);
		Handlebars.registerHelper('counterCheck', counter.check);
		Handlebars.registerHelper('counterReset', counter.reset);

		Handlebars.registerHelper('getCustomMotorName', customMotors.getCustomMotorName);
		Handlebars.registerHelper('checkIfCustomMotorProps', customMotors.checkIfCustomMotorProps);

		Handlebars.registerHelper('checkIfAnyTrue', checkIfAnyTrue);

		Handlebars.registerHelper('splitCamelCase', splitCamelCase);
		Handlebars.registerHelper('checkIfRoleIs', checkIfRoleIs);
		Handlebars.registerHelper('checkIfSpaDisplayed', checkIfSpaDisplayed);
		Handlebars.registerHelper('checkIfNotListed', checkIfNotListed);
		Handlebars.registerHelper('checkIfSpaSelected', checkIfSpaSelected);
		Handlebars.registerHelper('convertUnixTsToDate', convertUnixTsToDate);
		Handlebars.registerHelper('convertDateFormat', convertDateFormat);
		Handlebars.registerHelper('getCurrencyAndTotalPrice', getCurrencyAndTotalPrice);
		Handlebars.registerHelper('getCurrencyAndPrice', getCurrencyAndPrice);
		Handlebars.registerHelper('getAlias', getAlias);
		Handlebars.registerHelper('checkIfProductHaveKits', checkIfProductHaveKits);
		Handlebars.registerHelper('checkIfCompCatalog', checkIfCompCatalog);
		Handlebars.registerHelper('getClassIfProductIsKit', getClassIfProductIsKit);
		Handlebars.registerHelper('getDescriptionIfProductIsKit', getDescriptionIfProductIsKit);
		Handlebars.registerHelper('parseCompDescription', parseCompDescription);
		Handlebars.registerHelper('parseDataPack', parseDataPack);
		Handlebars.registerHelper('addAval',addAvailabilityList);
		Handlebars.registerHelper('stripDetails',stripDetails);
		Handlebars.registerHelper('addLocalVariable',addLocalVariable);
		Handlebars.registerHelper('equalString',equalString);
		};

	window.appSetup = appSetup;

})(window.appSetup || {});